"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalTrainerAdministrationApi = exports.PersonalTrainerAdministrationApiFactory = exports.PersonalTrainerAdministrationApiFp = exports.PersonalTrainerAdministrationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * PersonalTrainerAdministrationApi - axios parameter creator
 * @export
 */
const PersonalTrainerAdministrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: CreatePersonalTrainer - Difficulty: 3 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Kişisel antrenör oluşturmaya yarar. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. Kişisel antrenörlerin avatarları 2 farklı yerde gösterileceğinden, gönderilmiş imaj 2 farklı SaveUploadedPhoto komutuyla kaydolmalıdır. İlk SaveUploadedPhoto metodunun ikinci parametresi PhotoType.UserAvatar olmalıdır. İkinci SaveUploadedPhoto metodunun ikinci parametresi PhotoType.SmallUserAvatar olmalıdır.
         * @param {CreatePersonalTrainerCommand} [createPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonalTrainer: (createPersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/create_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: DeletePersonalTrainer - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenör hesabını silinmiş olarak işaretler. Avatarları IImageService\'te bulunan DeleteImage komutuyla silinmelidir. Bu noktada kişisel antrenörlerin aynı imageId\'ye sahip 2 farklı imajı olduğunu unutmayınız. 2 defa DeleteImage komutu kullanılarak bunlar temizlenmelidir. Bu noktada bir soru olması durumunda lütfen sormaktan çekinmeyiniz. İmajlar silindikten sonra değiştirilecek değerler: UserAccount tablosunda: Height => 0, Weight => 0, AvatarImageId => null, BirthDate => null, IsDeleted => true. User tablosu: email ve login alanları => (Buraya rastgele bir guid koyunuz)@deleted.account, firstName => Boş string, lastName => Boş string,
         * @param {DeletePersonalTrainerCommand} [deletePersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonalTrainer: (deletePersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/delete_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deletePersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: GetPersonalTrainerDetailsForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün detaylarını getirir.
         * @param {number} personalTrainerMetadataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalTrainerDetailsForAdministration: (personalTrainerMetadataId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personalTrainerMetadataId' is not null or undefined
            (0, common_1.assertParamExists)('getPersonalTrainerDetailsForAdministration', 'personalTrainerMetadataId', personalTrainerMetadataId);
            const localVarPath = `/api/personal_trainer_administration/get_personal_trainer_details_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (personalTrainerMetadataId !== undefined) {
                localVarQueryParameter['personalTrainerMetadataId'] = personalTrainerMetadataId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: GetStatisticsOfPersonalTrainerForAdministration - Difficulty: 3 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Bir yöneticinin kişisel antrenörün istatistik bilgilerini getirmesini sağlar.
         * @param {number} personalTrainerMetadataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsOfPersonalTrainerForAdministration: (personalTrainerMetadataId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personalTrainerMetadataId' is not null or undefined
            (0, common_1.assertParamExists)('getStatisticsOfPersonalTrainerForAdministration', 'personalTrainerMetadataId', personalTrainerMetadataId);
            const localVarPath = `/api/personal_trainer_administration/get_statistics_of_personal_trainer_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (personalTrainerMetadataId !== undefined) {
                localVarQueryParameter['personalTrainerMetadataId'] = personalTrainerMetadataId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListPersonalTrainerActivitiesForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Kişisel antrenörün aktivitelerini listeler.
         * @param {number} personalTrainerMetadataId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainerActivitiesForAdministration: (personalTrainerMetadataId, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'personalTrainerMetadataId' is not null or undefined
            (0, common_1.assertParamExists)('listPersonalTrainerActivitiesForAdministration', 'personalTrainerMetadataId', personalTrainerMetadataId);
            const localVarPath = `/api/personal_trainer_administration/list_personal_trainer_activities_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (personalTrainerMetadataId !== undefined) {
                localVarQueryParameter['personalTrainerMetadataId'] = personalTrainerMetadataId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListPersonalTrainersForAdministration - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Kişisel antrenörleri yönetmek için listeler. Kayıtlar UserAccount tablosundaki Id alanına göre tersten sıralanmalıdır. Default sayfa başı kayıt: 50 olmalıdır. Listelemeye sadece UserAccount entitysinde bulunan IsDeleted alanı false veya null olan kişisel antrenörleri dahil ediniz.
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainersForAdministration: (page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/list_personal_trainers_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateAvatarOfPersonalTrainer - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenör hesabının avatarını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. Kişisel antrenörlerin avatarları 2 farklı yerde gösterileceğinden, gönderilmiş imaj 2 farklı SaveUploadedPhoto komutuyla kaydolmalıdır. İlk SaveUploadedPhoto metodunun ikinci parametresi PhotoType.UserAvatar olmalıdır. İkinci SaveUploadedPhoto metodunun ikinci parametresi PhotoType.SmallUserAvatar olmalıdır. Bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateAvatarOfPersonalTrainerCommand} [updateAvatarOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvatarOfPersonalTrainer: (updateAvatarOfPersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/update_avatar_of_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateAvatarOfPersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateCommissionRateOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün komisyon oranını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateCommissionRateOfPersonalTrainerCommand} [updateCommissionRateOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommissionRateOfPersonalTrainer: (updateCommissionRateOfPersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/update_commission_rate_of_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCommissionRateOfPersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateEmailOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir antrenörün açıklamasını değiştirir.
         * @param {UpdateDescriptionOfPersonalTrainerCommand} [updateDescriptionOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfPersonalTrainer: (updateDescriptionOfPersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/update_description_of_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDescriptionOfPersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateEmailOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel e-posta adresini ve login bilgisini değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. E-postanın veritabanında tekrarlamadığı kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateEmailOfPersonalTrainerCommand} [updateEmailOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailOfPersonalTrainer: (updateEmailOfPersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/update_email_of_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateEmailOfPersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateNameOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün adını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateNameOfPersonalTrainerCommand} [updateNameOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNameOfPersonalTrainer: (updateNameOfPersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/update_name_of_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateNameOfPersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePackageCourseCommissionRateOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün paket kurs komisyon oranını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdatePackageCourseCommissionRateOfPersonalTrainerCommand} [updatePackageCourseCommissionRateOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackageCourseCommissionRateOfPersonalTrainer: (updatePackageCourseCommissionRateOfPersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/update_package_course_commission_rate_of_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePackageCourseCommissionRateOfPersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePasswordOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenör hesabının şifresini değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdatePasswordOfPersonalTrainerCommand} [updatePasswordOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePasswordOfPersonalTrainer: (updatePasswordOfPersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/update_password_of_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePasswordOfPersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePtOrderOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün sırasını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdatePtOrderOfPersonalTrainerCommand} [updatePtOrderOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePtOrderOfPersonalTrainer: (updatePtOrderOfPersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/update_pt_order_of_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePtOrderOfPersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateSurNameOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün soyadını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateSurNameOfPersonalTrainerCommand} [updateSurNameOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurNameOfPersonalTrainer: (updateSurNameOfPersonalTrainerCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/personal_trainer_administration/update_sur_name_of_personal_trainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSurNameOfPersonalTrainerCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PersonalTrainerAdministrationApiAxiosParamCreator = PersonalTrainerAdministrationApiAxiosParamCreator;
/**
 * PersonalTrainerAdministrationApi - functional programming interface
 * @export
 */
const PersonalTrainerAdministrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PersonalTrainerAdministrationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: CreatePersonalTrainer - Difficulty: 3 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Kişisel antrenör oluşturmaya yarar. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. Kişisel antrenörlerin avatarları 2 farklı yerde gösterileceğinden, gönderilmiş imaj 2 farklı SaveUploadedPhoto komutuyla kaydolmalıdır. İlk SaveUploadedPhoto metodunun ikinci parametresi PhotoType.UserAvatar olmalıdır. İkinci SaveUploadedPhoto metodunun ikinci parametresi PhotoType.SmallUserAvatar olmalıdır.
         * @param {CreatePersonalTrainerCommand} [createPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonalTrainer(createPersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPersonalTrainer(createPersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: DeletePersonalTrainer - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenör hesabını silinmiş olarak işaretler. Avatarları IImageService\'te bulunan DeleteImage komutuyla silinmelidir. Bu noktada kişisel antrenörlerin aynı imageId\'ye sahip 2 farklı imajı olduğunu unutmayınız. 2 defa DeleteImage komutu kullanılarak bunlar temizlenmelidir. Bu noktada bir soru olması durumunda lütfen sormaktan çekinmeyiniz. İmajlar silindikten sonra değiştirilecek değerler: UserAccount tablosunda: Height => 0, Weight => 0, AvatarImageId => null, BirthDate => null, IsDeleted => true. User tablosu: email ve login alanları => (Buraya rastgele bir guid koyunuz)@deleted.account, firstName => Boş string, lastName => Boş string,
         * @param {DeletePersonalTrainerCommand} [deletePersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonalTrainer(deletePersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePersonalTrainer(deletePersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: GetPersonalTrainerDetailsForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün detaylarını getirir.
         * @param {number} personalTrainerMetadataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalTrainerDetailsForAdministration(personalTrainerMetadataId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPersonalTrainerDetailsForAdministration(personalTrainerMetadataId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: GetStatisticsOfPersonalTrainerForAdministration - Difficulty: 3 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Bir yöneticinin kişisel antrenörün istatistik bilgilerini getirmesini sağlar.
         * @param {number} personalTrainerMetadataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsOfPersonalTrainerForAdministration(personalTrainerMetadataId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStatisticsOfPersonalTrainerForAdministration(personalTrainerMetadataId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListPersonalTrainerActivitiesForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Kişisel antrenörün aktivitelerini listeler.
         * @param {number} personalTrainerMetadataId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainerActivitiesForAdministration(personalTrainerMetadataId, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPersonalTrainerActivitiesForAdministration(personalTrainerMetadataId, page, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListPersonalTrainersForAdministration - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Kişisel antrenörleri yönetmek için listeler. Kayıtlar UserAccount tablosundaki Id alanına göre tersten sıralanmalıdır. Default sayfa başı kayıt: 50 olmalıdır. Listelemeye sadece UserAccount entitysinde bulunan IsDeleted alanı false veya null olan kişisel antrenörleri dahil ediniz.
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainersForAdministration(page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPersonalTrainersForAdministration(page, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateAvatarOfPersonalTrainer - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenör hesabının avatarını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. Kişisel antrenörlerin avatarları 2 farklı yerde gösterileceğinden, gönderilmiş imaj 2 farklı SaveUploadedPhoto komutuyla kaydolmalıdır. İlk SaveUploadedPhoto metodunun ikinci parametresi PhotoType.UserAvatar olmalıdır. İkinci SaveUploadedPhoto metodunun ikinci parametresi PhotoType.SmallUserAvatar olmalıdır. Bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateAvatarOfPersonalTrainerCommand} [updateAvatarOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvatarOfPersonalTrainer(updateAvatarOfPersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAvatarOfPersonalTrainer(updateAvatarOfPersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateCommissionRateOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün komisyon oranını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateCommissionRateOfPersonalTrainerCommand} [updateCommissionRateOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommissionRateOfPersonalTrainer(updateCommissionRateOfPersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCommissionRateOfPersonalTrainer(updateCommissionRateOfPersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateEmailOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir antrenörün açıklamasını değiştirir.
         * @param {UpdateDescriptionOfPersonalTrainerCommand} [updateDescriptionOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfPersonalTrainer(updateDescriptionOfPersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDescriptionOfPersonalTrainer(updateDescriptionOfPersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateEmailOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel e-posta adresini ve login bilgisini değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. E-postanın veritabanında tekrarlamadığı kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateEmailOfPersonalTrainerCommand} [updateEmailOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailOfPersonalTrainer(updateEmailOfPersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateEmailOfPersonalTrainer(updateEmailOfPersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateNameOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün adını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateNameOfPersonalTrainerCommand} [updateNameOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNameOfPersonalTrainer(updateNameOfPersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateNameOfPersonalTrainer(updateNameOfPersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePackageCourseCommissionRateOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün paket kurs komisyon oranını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdatePackageCourseCommissionRateOfPersonalTrainerCommand} [updatePackageCourseCommissionRateOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackageCourseCommissionRateOfPersonalTrainer(updatePackageCourseCommissionRateOfPersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePackageCourseCommissionRateOfPersonalTrainer(updatePackageCourseCommissionRateOfPersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePasswordOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenör hesabının şifresini değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdatePasswordOfPersonalTrainerCommand} [updatePasswordOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePasswordOfPersonalTrainer(updatePasswordOfPersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePasswordOfPersonalTrainer(updatePasswordOfPersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePtOrderOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün sırasını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdatePtOrderOfPersonalTrainerCommand} [updatePtOrderOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePtOrderOfPersonalTrainer(updatePtOrderOfPersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePtOrderOfPersonalTrainer(updatePtOrderOfPersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateSurNameOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün soyadını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateSurNameOfPersonalTrainerCommand} [updateSurNameOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurNameOfPersonalTrainer(updateSurNameOfPersonalTrainerCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSurNameOfPersonalTrainer(updateSurNameOfPersonalTrainerCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PersonalTrainerAdministrationApiFp = PersonalTrainerAdministrationApiFp;
/**
 * PersonalTrainerAdministrationApi - factory interface
 * @export
 */
const PersonalTrainerAdministrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PersonalTrainerAdministrationApiFp)(configuration);
    return {
        /**
         * Operation Id: CreatePersonalTrainer - Difficulty: 3 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Kişisel antrenör oluşturmaya yarar. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. Kişisel antrenörlerin avatarları 2 farklı yerde gösterileceğinden, gönderilmiş imaj 2 farklı SaveUploadedPhoto komutuyla kaydolmalıdır. İlk SaveUploadedPhoto metodunun ikinci parametresi PhotoType.UserAvatar olmalıdır. İkinci SaveUploadedPhoto metodunun ikinci parametresi PhotoType.SmallUserAvatar olmalıdır.
         * @param {CreatePersonalTrainerCommand} [createPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonalTrainer(createPersonalTrainerCommand, options) {
            return localVarFp.createPersonalTrainer(createPersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: DeletePersonalTrainer - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenör hesabını silinmiş olarak işaretler. Avatarları IImageService\'te bulunan DeleteImage komutuyla silinmelidir. Bu noktada kişisel antrenörlerin aynı imageId\'ye sahip 2 farklı imajı olduğunu unutmayınız. 2 defa DeleteImage komutu kullanılarak bunlar temizlenmelidir. Bu noktada bir soru olması durumunda lütfen sormaktan çekinmeyiniz. İmajlar silindikten sonra değiştirilecek değerler: UserAccount tablosunda: Height => 0, Weight => 0, AvatarImageId => null, BirthDate => null, IsDeleted => true. User tablosu: email ve login alanları => (Buraya rastgele bir guid koyunuz)@deleted.account, firstName => Boş string, lastName => Boş string,
         * @param {DeletePersonalTrainerCommand} [deletePersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonalTrainer(deletePersonalTrainerCommand, options) {
            return localVarFp.deletePersonalTrainer(deletePersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: GetPersonalTrainerDetailsForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün detaylarını getirir.
         * @param {number} personalTrainerMetadataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalTrainerDetailsForAdministration(personalTrainerMetadataId, options) {
            return localVarFp.getPersonalTrainerDetailsForAdministration(personalTrainerMetadataId, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: GetStatisticsOfPersonalTrainerForAdministration - Difficulty: 3 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Bir yöneticinin kişisel antrenörün istatistik bilgilerini getirmesini sağlar.
         * @param {number} personalTrainerMetadataId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsOfPersonalTrainerForAdministration(personalTrainerMetadataId, options) {
            return localVarFp.getStatisticsOfPersonalTrainerForAdministration(personalTrainerMetadataId, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListPersonalTrainerActivitiesForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Kişisel antrenörün aktivitelerini listeler.
         * @param {number} personalTrainerMetadataId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainerActivitiesForAdministration(personalTrainerMetadataId, page, options) {
            return localVarFp.listPersonalTrainerActivitiesForAdministration(personalTrainerMetadataId, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListPersonalTrainersForAdministration - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Kişisel antrenörleri yönetmek için listeler. Kayıtlar UserAccount tablosundaki Id alanına göre tersten sıralanmalıdır. Default sayfa başı kayıt: 50 olmalıdır. Listelemeye sadece UserAccount entitysinde bulunan IsDeleted alanı false veya null olan kişisel antrenörleri dahil ediniz.
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonalTrainersForAdministration(page, options) {
            return localVarFp.listPersonalTrainersForAdministration(page, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateAvatarOfPersonalTrainer - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenör hesabının avatarını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. Kişisel antrenörlerin avatarları 2 farklı yerde gösterileceğinden, gönderilmiş imaj 2 farklı SaveUploadedPhoto komutuyla kaydolmalıdır. İlk SaveUploadedPhoto metodunun ikinci parametresi PhotoType.UserAvatar olmalıdır. İkinci SaveUploadedPhoto metodunun ikinci parametresi PhotoType.SmallUserAvatar olmalıdır. Bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateAvatarOfPersonalTrainerCommand} [updateAvatarOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvatarOfPersonalTrainer(updateAvatarOfPersonalTrainerCommand, options) {
            return localVarFp.updateAvatarOfPersonalTrainer(updateAvatarOfPersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateCommissionRateOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün komisyon oranını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateCommissionRateOfPersonalTrainerCommand} [updateCommissionRateOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommissionRateOfPersonalTrainer(updateCommissionRateOfPersonalTrainerCommand, options) {
            return localVarFp.updateCommissionRateOfPersonalTrainer(updateCommissionRateOfPersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateEmailOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir antrenörün açıklamasını değiştirir.
         * @param {UpdateDescriptionOfPersonalTrainerCommand} [updateDescriptionOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfPersonalTrainer(updateDescriptionOfPersonalTrainerCommand, options) {
            return localVarFp.updateDescriptionOfPersonalTrainer(updateDescriptionOfPersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateEmailOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel e-posta adresini ve login bilgisini değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. E-postanın veritabanında tekrarlamadığı kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateEmailOfPersonalTrainerCommand} [updateEmailOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailOfPersonalTrainer(updateEmailOfPersonalTrainerCommand, options) {
            return localVarFp.updateEmailOfPersonalTrainer(updateEmailOfPersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateNameOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün adını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateNameOfPersonalTrainerCommand} [updateNameOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNameOfPersonalTrainer(updateNameOfPersonalTrainerCommand, options) {
            return localVarFp.updateNameOfPersonalTrainer(updateNameOfPersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePackageCourseCommissionRateOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün paket kurs komisyon oranını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdatePackageCourseCommissionRateOfPersonalTrainerCommand} [updatePackageCourseCommissionRateOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackageCourseCommissionRateOfPersonalTrainer(updatePackageCourseCommissionRateOfPersonalTrainerCommand, options) {
            return localVarFp.updatePackageCourseCommissionRateOfPersonalTrainer(updatePackageCourseCommissionRateOfPersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePasswordOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenör hesabının şifresini değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdatePasswordOfPersonalTrainerCommand} [updatePasswordOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePasswordOfPersonalTrainer(updatePasswordOfPersonalTrainerCommand, options) {
            return localVarFp.updatePasswordOfPersonalTrainer(updatePasswordOfPersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePtOrderOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün sırasını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdatePtOrderOfPersonalTrainerCommand} [updatePtOrderOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePtOrderOfPersonalTrainer(updatePtOrderOfPersonalTrainerCommand, options) {
            return localVarFp.updatePtOrderOfPersonalTrainer(updatePtOrderOfPersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateSurNameOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Bir kişisel antrenörün soyadını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
         * @param {UpdateSurNameOfPersonalTrainerCommand} [updateSurNameOfPersonalTrainerCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurNameOfPersonalTrainer(updateSurNameOfPersonalTrainerCommand, options) {
            return localVarFp.updateSurNameOfPersonalTrainer(updateSurNameOfPersonalTrainerCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PersonalTrainerAdministrationApiFactory = PersonalTrainerAdministrationApiFactory;
/**
 * PersonalTrainerAdministrationApi - object-oriented interface
 * @export
 * @class PersonalTrainerAdministrationApi
 * @extends {BaseAPI}
 */
class PersonalTrainerAdministrationApi extends base_1.BaseAPI {
    /**
     * Operation Id: CreatePersonalTrainer - Difficulty: 3 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
     * @summary Kişisel antrenör oluşturmaya yarar. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. Kişisel antrenörlerin avatarları 2 farklı yerde gösterileceğinden, gönderilmiş imaj 2 farklı SaveUploadedPhoto komutuyla kaydolmalıdır. İlk SaveUploadedPhoto metodunun ikinci parametresi PhotoType.UserAvatar olmalıdır. İkinci SaveUploadedPhoto metodunun ikinci parametresi PhotoType.SmallUserAvatar olmalıdır.
     * @param {CreatePersonalTrainerCommand} [createPersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    createPersonalTrainer(createPersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).createPersonalTrainer(createPersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: DeletePersonalTrainer - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kişisel antrenör hesabını silinmiş olarak işaretler. Avatarları IImageService\'te bulunan DeleteImage komutuyla silinmelidir. Bu noktada kişisel antrenörlerin aynı imageId\'ye sahip 2 farklı imajı olduğunu unutmayınız. 2 defa DeleteImage komutu kullanılarak bunlar temizlenmelidir. Bu noktada bir soru olması durumunda lütfen sormaktan çekinmeyiniz. İmajlar silindikten sonra değiştirilecek değerler: UserAccount tablosunda: Height => 0, Weight => 0, AvatarImageId => null, BirthDate => null, IsDeleted => true. User tablosu: email ve login alanları => (Buraya rastgele bir guid koyunuz)@deleted.account, firstName => Boş string, lastName => Boş string,
     * @param {DeletePersonalTrainerCommand} [deletePersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    deletePersonalTrainer(deletePersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).deletePersonalTrainer(deletePersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: GetPersonalTrainerDetailsForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kişisel antrenörün detaylarını getirir.
     * @param {number} personalTrainerMetadataId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    getPersonalTrainerDetailsForAdministration(personalTrainerMetadataId, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).getPersonalTrainerDetailsForAdministration(personalTrainerMetadataId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: GetStatisticsOfPersonalTrainerForAdministration - Difficulty: 3 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
     * @summary Bir yöneticinin kişisel antrenörün istatistik bilgilerini getirmesini sağlar.
     * @param {number} personalTrainerMetadataId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    getStatisticsOfPersonalTrainerForAdministration(personalTrainerMetadataId, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).getStatisticsOfPersonalTrainerForAdministration(personalTrainerMetadataId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListPersonalTrainerActivitiesForAdministration - Difficulty: 3 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Kişisel antrenörün aktivitelerini listeler.
     * @param {number} personalTrainerMetadataId
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    listPersonalTrainerActivitiesForAdministration(personalTrainerMetadataId, page, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).listPersonalTrainerActivitiesForAdministration(personalTrainerMetadataId, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListPersonalTrainersForAdministration - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Kişisel antrenörleri yönetmek için listeler. Kayıtlar UserAccount tablosundaki Id alanına göre tersten sıralanmalıdır. Default sayfa başı kayıt: 50 olmalıdır. Listelemeye sadece UserAccount entitysinde bulunan IsDeleted alanı false veya null olan kişisel antrenörleri dahil ediniz.
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    listPersonalTrainersForAdministration(page, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).listPersonalTrainersForAdministration(page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateAvatarOfPersonalTrainer - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kişisel antrenör hesabının avatarını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Gönderilmiş bir imaj IImageService\'te bulunan SaveUploadedPhoto metoduyla kaydedilir. Kişisel antrenörlerin avatarları 2 farklı yerde gösterileceğinden, gönderilmiş imaj 2 farklı SaveUploadedPhoto komutuyla kaydolmalıdır. İlk SaveUploadedPhoto metodunun ikinci parametresi PhotoType.UserAvatar olmalıdır. İkinci SaveUploadedPhoto metodunun ikinci parametresi PhotoType.SmallUserAvatar olmalıdır. Bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
     * @param {UpdateAvatarOfPersonalTrainerCommand} [updateAvatarOfPersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    updateAvatarOfPersonalTrainer(updateAvatarOfPersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).updateAvatarOfPersonalTrainer(updateAvatarOfPersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateCommissionRateOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kişisel antrenörün komisyon oranını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
     * @param {UpdateCommissionRateOfPersonalTrainerCommand} [updateCommissionRateOfPersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    updateCommissionRateOfPersonalTrainer(updateCommissionRateOfPersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).updateCommissionRateOfPersonalTrainer(updateCommissionRateOfPersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateEmailOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir antrenörün açıklamasını değiştirir.
     * @param {UpdateDescriptionOfPersonalTrainerCommand} [updateDescriptionOfPersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    updateDescriptionOfPersonalTrainer(updateDescriptionOfPersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).updateDescriptionOfPersonalTrainer(updateDescriptionOfPersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateEmailOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kişisel e-posta adresini ve login bilgisini değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. E-postanın veritabanında tekrarlamadığı kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
     * @param {UpdateEmailOfPersonalTrainerCommand} [updateEmailOfPersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    updateEmailOfPersonalTrainer(updateEmailOfPersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).updateEmailOfPersonalTrainer(updateEmailOfPersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateNameOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kişisel antrenörün adını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
     * @param {UpdateNameOfPersonalTrainerCommand} [updateNameOfPersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    updateNameOfPersonalTrainer(updateNameOfPersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).updateNameOfPersonalTrainer(updateNameOfPersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePackageCourseCommissionRateOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kişisel antrenörün paket kurs komisyon oranını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
     * @param {UpdatePackageCourseCommissionRateOfPersonalTrainerCommand} [updatePackageCourseCommissionRateOfPersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    updatePackageCourseCommissionRateOfPersonalTrainer(updatePackageCourseCommissionRateOfPersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).updatePackageCourseCommissionRateOfPersonalTrainer(updatePackageCourseCommissionRateOfPersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePasswordOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kişisel antrenör hesabının şifresini değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
     * @param {UpdatePasswordOfPersonalTrainerCommand} [updatePasswordOfPersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    updatePasswordOfPersonalTrainer(updatePasswordOfPersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).updatePasswordOfPersonalTrainer(updatePasswordOfPersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePtOrderOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kişisel antrenörün sırasını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
     * @param {UpdatePtOrderOfPersonalTrainerCommand} [updatePtOrderOfPersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    updatePtOrderOfPersonalTrainer(updatePtOrderOfPersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).updatePtOrderOfPersonalTrainer(updatePtOrderOfPersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateSurNameOfPersonalTrainer - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Bir kişisel antrenörün soyadını değiştirir. Kişisel antrenörün varlığı PersonalTrainerMetadata entitysinden kontrol edilmelidir. Aynı zamanda bilgileri değiştirilmek istenilen kişisel antrenörün UserAccount entitysi içerisindeki IsDeleted değeri false yada null olmalıdır.
     * @param {UpdateSurNameOfPersonalTrainerCommand} [updateSurNameOfPersonalTrainerCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalTrainerAdministrationApi
     */
    updateSurNameOfPersonalTrainer(updateSurNameOfPersonalTrainerCommand, options) {
        return (0, exports.PersonalTrainerAdministrationApiFp)(this.configuration).updateSurNameOfPersonalTrainer(updateSurNameOfPersonalTrainerCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PersonalTrainerAdministrationApi = PersonalTrainerAdministrationApi;
